var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgFileUpload = function SvgFileUpload(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 38,
    height: 46,
    fill: "none",
    viewBox: "0 0 38 46"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#E3E3E3",
    d: "M36 46H2a2 2 0 0 1-2-2V2a2 2 0 0 1 2-2h24l12 12v32a2 2 0 0 1-2 2"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#AEAEAE",
    d: "M26 0v10a2 2 0 0 0 2 2h10z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "#404040",
    d: "m27.707 20.293-8-8a1 1 0 0 0-1.415 0l-8 8a1 1 0 1 0 1.414 1.414L18 15.414V33a1 1 0 1 0 2 0V15.414l6.293 6.293a1 1 0 0 0 1.414-1.414"
  })));
};
export default SvgFileUpload;